const getLocalizedString = (locale, localizedStrings) => {
  if (!localizedStrings) {
    return "";
  }
  let value = localizedStrings.find((string) => string.locale === locale)?.value;
  if (value === void 0) {
    value = localizedStrings.find((string) => string.locale.substr(0, 2) === "en")?.value;
  }
  return value || "";
};
export {
  getLocalizedString
};
//# sourceMappingURL=get-localized-string.js.map
